document.addEventListener('click', function (event) {
  const playBtn = event.target.closest('[data-play-video-btn]');

  if (!playBtn) return;

  const videoWrapper = playBtn.closest('.slideshow__video');
  if (!videoWrapper) return;

  const video = videoWrapper.querySelector('video');
  if (!video) return;

  video.play();
  videoWrapper.classList.add('playing');

  video.addEventListener('ended', function () {
    videoWrapper.classList.remove('playing');
  }, { once: true });
});

document.addEventListener('click', function (event) {
  const image = event.target.closest('.social-media__image[data-hasmodal]');
  const close = event.target.closest('.close-social-media-image-modal');

  if (image) {
    const parent = image.closest('.social-media__block');

    if (!parent) return;

    parent.classList.add('active');
  }

  if (close) {
    const parent = close.closest('.social-media__block');

    if (!parent) return;

    parent.classList.remove('active');
  }
});

document.addEventListener('DOMContentLoaded', () => {
  const triggers = document.querySelectorAll('.pdp-comparrison-scroll-to');
  const target = document.querySelector('.pricing-table');

  if (!triggers.length || !target) return;

  const smoothScrollTo = (endPosition, duration = 700) => {
    const startPosition = window.scrollY;
    const distance = endPosition - startPosition;
    let startTime = null;

    const easeInOutCubic = (progress) => {
      return progress < 0.5
        ? 4 * progress * progress * progress
        : 1 - Math.pow(-2 * progress + 2, 3) / 2;
    };

    const animation = (currentTime) => {
      if (startTime === null) {
        startTime = currentTime;
      }

      const elapsed = currentTime - startTime;
      const progress = Math.min(elapsed / duration, 1);
      const easedProgress = easeInOutCubic(progress);

      window.scrollTo(0, startPosition + distance * easedProgress);

      if (progress < 1) {
        requestAnimationFrame(animation);
      }
    };

    requestAnimationFrame(animation);
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('click', (event) => {
      event.preventDefault();

      const headerOffset = 0;
      const targetPosition =
        target.getBoundingClientRect().top +
        window.scrollY -
        headerOffset;

      smoothScrollTo(targetPosition);
    });
  });
});

document.addEventListener('click', function (event) {
  const trigger = event.target.closest('a.js-open-intercom, a[href="#open-intercom"]');
  if (!trigger) return;

  event.preventDefault();

  const defaultMessage = "Hi — I'd like to book a demo";
  const message = (trigger.getAttribute('data-intercom-message') || '').trim() || defaultMessage;
  const fallbackUrl = '/pages/contact';
  const maxAttempts = 20;
  const retryMs = 250;

  const openIntercom = (attempt) => {
    if (typeof window.Intercom === 'function') {
      window.Intercom('startConversation', message);
      return;
    }

    if (attempt >= maxAttempts) {
      window.location.href = fallbackUrl;
      return;
    }

    window.setTimeout(function () {
      openIntercom(attempt + 1);
    }, retryMs);
  };

  openIntercom(0);
});